export type SortDirection = 'asc' | 'desc' | '';

export function getPathFromColumns(
  columns: Array<{ column: string; propertyDisplay?: string }>,
  active: string,
): string {
  const meta = columns?.find(c => c.column === active);
  return meta?.propertyDisplay || active;
}

export function getByPath(obj: any, path: string): any {
  try {
    if (!obj || !path) return '';
    if (path.includes('.')) {
      return path.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), obj);
    }
    return obj[path];
  } catch {
    return '';
  }
}

export function normalizeForSort(v: any): any {
  if (v === null || v === undefined) return '';
  if (typeof v === 'string') return v.toString().toLowerCase();
  if (typeof v === 'number') return v;
  if (typeof v === 'boolean') return v ? 1 : 0;
  return v?.toString?.().toLowerCase?.() ?? '';
}

export function sortByPath<T>(data: T[], path: string, direction: SortDirection): T[] {
  if (!direction) return data.slice();
  const copy = data.slice();
  copy.sort((a: any, b: any) => {
    const va = normalizeForSort(getByPath(a, path));
    const vb = normalizeForSort(getByPath(b, path));
    if (va < vb) return direction === 'asc' ? -1 : 1;
    if (va > vb) return direction === 'asc' ? 1 : -1;
    return 0;
  });
  return copy;
}
